import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OurServicesComponent } from './our-services.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { LineOfBusinessCardModule } from 'src/app/main/service/line-of-business-card/line-of-business-card.module';
import { CarouselModule } from 'src/app/components/carousel/carousel.module';



@NgModule({
  declarations: [
    OurServicesComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    CarouselModule,
    LineOfBusinessCardModule,
  ],
  exports: [
    OurServicesComponent
  ]
})
export class OurServicesModule { }
